module.exports = __webpack_public_path__ + "img/logo-olivia-garden.e5301975.jpg";